import { Stack, styled, Typography } from '@mui/material';

import { Button, Link } from '@rumblefish/ui/src/components/Rumblefish23Theme';

import chequered from '../../../public/webp/fromPNG/chequered.webp';
import rumbleStamp from '../../../public/webp/fromPNG/rumble-stamp-orange-white.webp';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(12, 0, 12, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(12, 0),
  },
}));

export const StyledWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const StyledImg = styled('div')(() => ({
  background: `url(${rumbleStamp})`,
  backgroundSize: '100%',
  width: '125px',
  height: '125px',
  backgroundRepeat: 'no-repeat',
}));

export const StyledTitle = styled('div')(({ theme }) => ({
  fontWeight: '700',
  fontSize: '3vw',
  lineHeight: '100%',
  letterSpacing: '-0.02em',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  textAlign: 'center',
  marginTop: '7%',
  marginBottom: '5%',
  [theme.breakpoints.down('sm')]: {
    fontSize: '8vw',
  },
}));

export const StyledButtonWrapper = styled(Stack)({
  display: 'flex',
  alignItems: 'center',
});

export const StyledLink = styled(Link)(({ theme }) => ({
  margin: theme.spacing(2, 0, 1, 1),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.orangeColors?.PLUS_2}, 0px 0px 6px 4px ${theme.palette.orangeColors?.PLUS_2} inset !important`,
  },
}));

export const StyledLetsDiscussMobile = styled('div')(({ theme }) => ({
  justifyItems: 'center',
  marginTop: '150% ',
  marginBottom: '0%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const StyledHowItWorks = styled('div')(({ theme: { breakpoints } }) => ({
  paddingLeft: '20%',
  paddingRight: '20%',
  paddingTop: '5%',
  paddingBottom: '10%',
  marginTop: '20%',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.05), rgba(24, 31, 31, 0.4)), url(${chequered})`,
  backgroundBlendMode: 'darken',
  borderRadius: '24px',
  [breakpoints.down('sm')]: {
    padding: '2%',
    marginBottom: '12%',
    marginTop: 0,
    width: '90vw',
    backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.05), rgba(24, 31, 31, 0.4))`,
  },
}));

export const StyledText = styled('div')(({ theme }) => ({
  ['p']: {
    fontWeight: '700',
    fontSize: '4vw',
    lineHeight: '100%',
    letterSpacing: '-0.02em',
    background:
      'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18vw',
    },
  },
}));

export const StyledTwoFeatures = styled('div')(({ theme }) => ({
  ['img']: {
    height: '80px',
    width: '80px',
  },
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  marginTop: '10%',
  ['div:first-child']: {
    borderRight: '1px solid rgba(217, 217, 217, 0.1)',
    paddingRight: '10%',
  },
  ['div:nth-of-type(2)']: {
    paddingLeft: '10%',
  },

  [theme.breakpoints.down('sm')]: {
    ['div:first-child']: {
      borderRight: 'none',
      paddingRight: '0%',
    },
    ['div:nth-of-type(2)']: {
      paddingLeft: '0%',
    },
    gridTemplateColumns: 'none',
    gridAutoFlow: 'row',
  },
}));

export const StyledBigWhite = styled('div')(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  fontSize: '1.2vw',
  letterSpacing: '-0.02em',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '5%',
    marginTop: '-10%',
    fontSize: '5vw',
  },
}));

export const StyledFeature = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  ['p']: {
    fontSize: '24px',
    color: theme.palette.invertedContent?.PRIMARY,
    fontWeight: 650,
  },
  ['span']: {
    color: '#ABB1B4',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: '10%',
  },
}));

export const CompaniesStyledStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(7),
  marginTop: theme.spacing(12),
  textAlign: 'center',
}));

export const StyledCompaniesHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));
